function MainHeader(el) {
    this.el = el;

    this.initSlider();
    this.initVideo();
}

MainHeader.prototype.initSlider = function() {
    this.slider = this.el.querySelector('.jsMainHeaderSlider');

    if (this.slider) {
        new Flickity(this.slider, {
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            autoPlay: 4000,
            draggable: false,
            pauseAutoPlayOnHover: false
        });
    }
};

MainHeader.prototype.initVideo = function() {
    this.video = this.el.querySelector('.jsMainHeaderVideo');

    if (this.video) {
        this.setVideoDimensions();
        window.addEventListener('resize', _ => this.setVideoDimensions());
    }
};

MainHeader.prototype.setVideoDimensions = function() {
    let width = this.el.offsetWidth;
    let height = width / 16 * 9;

    if (height < this.el.offsetHeight) {
        height = this.el.offsetHeight;
        width = height / 9 * 16;
    }

    this.video.style.width = width + 'px';
    this.video.style.height = height + 'px';
};

(function() {
    const mainHeader = document.querySelector('.jsMainHeader');
    if (mainHeader) new MainHeader(mainHeader);
})();
